// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import axios from "axios";

// const MatirialReceipt = () => {

//   // ===== Screen Mode =====
//   const [screenAction, setScreenAction] = useState("");

//   // ===== User from localStorage =====
//   const user = JSON.parse(localStorage.getItem("user")) || {};

//   // ===== Header Data =====
//   const [mrnHdrData, setMrnHdrData] = useState({
//     MRN_Dt: "",
//     Invoice_no: "",
//     Invoice_dt: "",
//     Dc_no: "",
//     DC_Dt: "",
//     Security_no: "",
//     Security_dt: "",
//     Supplier_cd: "",
//     Credit_days: "",
//     Due_dt: "",
//     Des_gst: "",
//     Des_state_cd: "",
//     Supp_gst: "",
//     Supp_state_cd: ""
//   });

//   // ===== Detail Data =====
//   const [mrnDtlData, setMrnDtlData] = useState([]);

//   // ===== MRN Dropdown =====
//   const [mrnOptions, setMrnOptions] = useState([]);
//   const [selectedMRNNo, setSelectedMRNNo] = useState("");

//   // ===== PO Selection =====
//   const [selectedPOs, setSelectedPOs] = useState([]);
//   const [quantities, setQuantities] = useState({});

//   // ====================================================
//   // SCREEN ACTION EFFECT
//   // ====================================================
//   useEffect(() => {

//     if (screenAction === "add") {
//       handleRefresh();
//     }

//     if (screenAction === "edit") {
//       getMRNList();
//     }

//     if (screenAction === "view") {
//       getMRNList();
//     }

//     if (screenAction === "save") {
//       handleSave();
//     }

//   }, [screenAction]);

//   // ====================================================
//   // REFRESH
//   // ====================================================
//   const handleRefresh = () => {
//     setMrnHdrData({});
//     setMrnDtlData([]);
//     setSelectedPOs([]);
//     setQuantities({});
//     setSelectedMRNNo("");
//   };

//   // ====================================================
//   // GET MRN LIST
//   // ====================================================
//   const getMRNList = async () => {
//     const res = await axios.get("/API/MRN_LIST");
//     const options = res.data.map(item => ({
//       value: item.MRN_No,
//       label: item.MRN_No
//     }));
//     setMrnOptions(options);
//   };

//   // ====================================================
//   // MRN CHANGE (FOR EDIT / VIEW)
//   // ====================================================
//   const handleMRNChange = async (selectedOption) => {
//     setSelectedMRNNo(selectedOption.value);

//     const res = await axios.get(`/API/MRN/${selectedOption.value}`);

//     setMrnHdrData(res.data.MRN_HDR);
//     setMrnDtlData(res.data.MRN_DTL);
//   };

//   // ====================================================
//   // SAVE
//   // ====================================================
//   const handleSave = async () => {

//     const MRN_HDR = {
//       ...mrnHdrData,
//       Created_by: user?.id
//     };

//     const MRN_DTL = mrnDtlData;

//     if (screenAction === "add") {
//       await axios.post("/API/MRN", { MRN_HDR, MRN_DTL });
//       alert("MRN Saved");
//     }

//     if (screenAction === "edit") {
//       await axios.put(`/API/MRN/${selectedMRNNo}`, { MRN_HDR, MRN_DTL });
//       alert("MRN Updated");
//     }

//     setScreenAction("");
//     handleRefresh();
//   };

//   // ====================================================
//   // ROWS TO DISPLAY (FOR VIEW/EDIT TABLE)
//   // ====================================================
//   const rowsToDisplay = mrnDtlData.length > 0
//     ? mrnDtlData
//     : Array(5).fill({});

//   // ====================================================
//   // RENDER
//   // ====================================================
//   return (
//     <div>

//       {/* ================= Toolbar ================= */}
//       <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
//         <button onClick={() => setScreenAction("add")}>Add</button>
//         <button onClick={() => setScreenAction("edit")}>Edit</button>
//         <button onClick={() => setScreenAction("view")}>View</button>
//         <button onClick={() => setScreenAction("save")}>Save</button>
//         <button onClick={handleRefresh}>Refresh</button>
//       </div>

//       {/* ================= ADD FORM ================= */}
//       {screenAction === "add" && (
//         <div>
//           <h3>Material Receipt - Add</h3>

//           {/* HEADER FORM */}
//           <div style={{ display: "flex", gap: "50px" }}>
//             <input
//               placeholder="Invoice No"
//               value={mrnHdrData.Invoice_no || ""}
//               onChange={(e) =>
//                 setMrnHdrData({ ...mrnHdrData, Invoice_no: e.target.value })
//               }
//             />

//             <input
//               type="date"
//               value={mrnHdrData.Invoice_dt || ""}
//               onChange={(e) =>
//                 setMrnHdrData({ ...mrnHdrData, Invoice_dt: e.target.value })
//               }
//             />
//           </div>

//           {/* ================= YOUR PO TABLE HERE ================= */}
//           {/* Paste your selectedPOs.map table code here */}

//         </div>
//       )}

//       {/* ================= VIEW FORM ================= */}
//       {screenAction === "view" && (
//         <div>
//           <h3>Material Receipt - View</h3>

//           <Select
//             options={mrnOptions}
//             value={mrnOptions.find(
//               (option) => option.value === selectedMRNNo
//             )}
//             onChange={handleMRNChange}
//             placeholder="Search MRN No"
//           />

//           {/* VIEW TABLE */}
//           <table border="1" width="100%">
//             <thead>
//               <tr>
//                 <th>SI.No</th>
//                 <th>PO No</th>
//                 <th>Item Code</th>
//                 <th>UOM</th>
//                 <th>PO Qty</th>
//                 <th>Received Qty</th>
//                 <th>Accepted Qty</th>
//                 <th>Total Cost</th>
//                 <th>Rejected Qty</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rowsToDisplay.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.PO_No}</td>
//                   <td>{item.Item_cd}</td>
//                   <td>{item.UOM}</td>
//                   <td>{item.PO_qty}</td>
//                   <td>{item.Received_qty}</td>
//                   <td>{item.Accepted_qty}</td>
//                   <td>{item.Total_Item_Cost}</td>
//                   <td>{item.Rejected_qty}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ================= EDIT FORM ================= */}
//       {screenAction === "edit" && (
//         <div>
//           <h3>Material Receipt - Edit</h3>

//           <Select
//             options={mrnOptions}
//             value={mrnOptions.find(
//               (option) => option.value === selectedMRNNo
//             )}
//             onChange={handleMRNChange}
//             placeholder="Search MRN No"
//           />

//           {/* EDIT TABLE */}
//           <table border="1" width="100%">
//             <thead>
//               <tr>
//                 <th>SI.No</th>
//                 <th>PO No</th>
//                 <th>Item Code</th>
//                 <th>UOM</th>
//                 <th>PO Qty</th>
//                 <th>Received Qty</th>
//                 <th>Accepted Qty</th>
//                 <th>Total Cost</th>
//                 <th>Rejected Qty</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rowsToDisplay.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.PO_No}</td>
//                   <td>{item.Item_cd}</td>
//                   <td>{item.UOM}</td>
//                   <td>{item.PO_qty}</td>

//                   <td>
//                     <input
//                       value={item.Received_qty || ""}
//                       onChange={(e) => {
//                         const updated = [...mrnDtlData];
//                         updated[index].Received_qty = e.target.value;
//                         setMrnDtlData(updated);
//                       }}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       value={item.Accepted_qty || ""}
//                       onChange={(e) => {
//                         const updated = [...mrnDtlData];
//                         updated[index].Accepted_qty = e.target.value;
//                         updated[index].Total_Item_Cost =
//                           e.target.value * updated[index].Actual_Rate;
//                         setMrnDtlData(updated);
//                       }}
//                     />
//                   </td>

//                   <td>{item.Total_Item_Cost}</td>

//                   <td>
//                     <input
//                       value={item.Rejected_qty || ""}
//                       onChange={(e) => {
//                         const updated = [...mrnDtlData];
//                         updated[index].Rejected_qty = e.target.value;
//                         setMrnDtlData(updated);
//                       }}
//                     />
//                   </td>

//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//     </div>
//   );
// };

// export default MatirialReceipt;

// import React, { useEffect, useState } from "react";
// import Select from "react-select";

// const MaterialReceipt = ({ screenAction }) => {

//   const [formMode, setFormMode] = useState("create");
//   const [showSearch, setShowSearch] = useState(false);

//   const [mrnHdrData, setMrnHdrData] = useState({});
//   const [rowsToDisplay, setRowsToDisplay] = useState([]);
//   const [mrnOptions, setMrnOptions] = useState([]);
//   const [selectedMRNNo, setSelectedMRNNo] = useState(null);

//   // ✅ SAME AS INDENT (SCREEN CONTROL)
//   useEffect(() => {
//     if (!screenAction) return;

//     if (screenAction === "add") {
//       setFormMode("create");
//       setShowSearch(false);
//       clearForm();
//     }

//     if (screenAction === "edit") {
//       setFormMode("edit");
//       setShowSearch(true);
//     }

//     if (screenAction === "view") {
//       setFormMode("view");
//       setShowSearch(true);
//     }

//   }, [screenAction]);

//   const clearForm = () => {
//     setMrnHdrData({});
//     setRowsToDisplay([]);
//   };

//   const handleMRNChange = (selected) => {
//     setSelectedMRNNo(selected.value);
//     // call your existing API here
//   };

//   const isViewMode = formMode === "view";

//   return (
//     <div className="indent-container">

//       {/* 🔍 SEARCH (Same like Indent) */}
//       {showSearch && (
//         <div className="search-box">
//           <div>
//             <label>MRN No</label>
//             <Select
//               options={mrnOptions}
//               value={mrnOptions.find(o => o.value === selectedMRNNo)}
//               onChange={handleMRNChange}
//               placeholder="Search MRN No"
//             />
//           </div>
//         </div>
//       )}

//       {/* 📄 HEADER FORM */}
//       <div className="indent-form">

//         <div className="form-row">
//           <label>Invoice No</label>
//           <input value={mrnHdrData.Invoice_no || ""} readOnly={isViewMode} />
//         </div>

//         <div className="form-row">
//           <label>DC No</label>
//           <input value={mrnHdrData.Dc_no || ""} readOnly={isViewMode} />
//         </div>

//         <div className="form-row">
//           <label>Security No</label>
//           <input value={mrnHdrData.Security_no || ""} readOnly={isViewMode} />
//         </div>

//         <div className="form-row">
//           <label>MRN Date</label>
//           <input
//             type="date"
//             value={mrnHdrData.MRN_Dt || ""}
//             readOnly={isViewMode}
//           />
//         </div>

//         <div className="form-row">
//           <label>Supplier</label>
//           <input value={mrnHdrData.Supplier_name || ""} readOnly />
//         </div>

//       </div>

//       {/* 📊 TABLE (YOUR LOGIC KEPT SAME) */}
//       <div className="indent-table">
//         <table>
//           <thead>
//             <tr>
//               <th>Sl No</th>
//               <th>PO No</th>
//               <th>Item Code</th>
//               <th>UOM</th>
//               <th>PO Qty</th>
//               <th>Received Qty</th>
//               <th>Accepted Qty</th>
//               <th>Total Cost</th>
//               <th>Rejected Qty</th>
//             </tr>
//           </thead>

//           <tbody>
//             {rowsToDisplay.map((item, index) => {

//               const accepted = parseFloat(item.Accepted_qty) || 0;
//               const received = parseFloat(item.Received_qty) || 0;
//               const rate = parseFloat(item.Actual_Rate) || 0;

//               return (
//                 <tr key={index}>
//                   <td>{index + 1}</td>

//                   <td>{item.PO_no}</td>
//                   <td>{item.itemCd}</td>
//                   <td>{item.UOM}</td>
//                   <td>{item.PO_qty}</td>

//                   <td>
//                     <input
//                       value={item.Received_qty}
//                       readOnly={isViewMode}
//                     />
//                   </td>

//                   <td>
//                     <input
//                       value={item.Accepted_qty}
//                       readOnly={isViewMode}
//                     />
//                   </td>

//                   <td>
//                     {(accepted > 0
//                       ? accepted * rate
//                       : rate
//                     ).toFixed(2)}
//                   </td>

//                   <td>
//                     {(received - accepted > 0
//                       ? received - accepted
//                       : 0
//                     ).toFixed(2)}
//                   </td>

//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//     </div>
//   );
// };

// export default MaterialReceipt;



import React, { useEffect, useState } from 'react';
import { FaCheck, FaPlus, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select';

const MatirialReceipt = ({ screenAction, selectedData, onBack }) => {

  const [formMode, setFormMode] = useState('');


  // useEffect(() => {
  //   if (!screenAction) return;

  //   switch (screenAction) {
  //     case "add":
  //       // resetForm();
  //       setFormMode("create");
  //       setShowCreateForm(true);
  //       setShowViewForm(false);
  //       setShowEditForm(false);
  //       setIsModalOpen(true);
  //       setFormData({
  //         Credit_Days: "",
  //         DC_Date: "",
  //         Dc_No: "",
  //         Due_Date: "",
  //         Invoice_Date: "",
  //         Invoice_No: "",
  //         MRN_No: "",
  //         Security_Date: "",
  //         Security_No: "",
  //       });
  //       setQuantities({});
  //       setSelectedPOs([]);
  //       // resetForm();
  //       break;

  //     case "edit":
  //       // setFormMode("edit");
  //       // setShowCreateForm(false);
  //       setFormMode('edit');
  //       setShowViewForm(false);
  //       setShowEditForm(true);
  //       if (selectedData)
  //         // fetchPOData(selectedData);
  //         break;

  //     case "view":
  //       // setFormMode("view");
  //       setShowCreateForm(false);
  //       setShowViewForm(true);
  //       setShowEditForm(false);
  //       setFormMode('view');
  //       if (selectedData)
  //         //fetchPOData(selectedData);
  //         break;

  //     case "approve":
  //       setFormMode("approve");
  //       if (selectedData)
  //         // fetchPOData(selectedData);
  //         break;

  //     // case "save":
  //     //   if (formMode === "approve") {
  //     //     handleApprove();
  //     //   } else {
  //     //     handleSave();
  //     //   }
  //     //   break;


  //     // case "save":
  //     //   if (formMode === "view") return; // 🚫 don't save in view mode

  //     //   if (formMode === "edit") 
  //     //     {
  //     //     handleEditSubmit();
  //     //      return;
  //     //   }


  //     //   if(formMode === 'create')
  //     //   {
  //     //     handleSave();
  //     //      return;
  //     //   }

  //     //   break;


  //     case "save":
  //       if (formMode === "view") return;

  //       // 🚫 Prevent accidental repeated call
  //       if (!selectedPOs.length && formMode === "create") return;

  //       if (formMode === "edit") {
  //         handleEditSubmit();
  //       } else if (formMode === "create") {
  //         handleSave();
  //       }
  //       break;


  //     case "clear":
  //       // resetForm();
  //       break;

  //     case "print":
  //       handlePrint();
  //       break;

  //     case "close":
  //       onBack();
  //       break;

  //     default:
  //       break;
  //   }
  // }, [screenAction]);


  const lastActionRef = React.useRef(null);

  useEffect(() => {
    if (!screenAction) return;

    // 🚫 Prevent same action repeating
    if (lastActionRef.current === screenAction) return;

    lastActionRef.current = screenAction;

    switch (screenAction) {

      case "add":
        setFormMode("create");
        setShowCreateForm(true);
        setShowViewForm(false);
        setShowEditForm(false);
        setIsModalOpen(true);
        // setFormData({
        //   Credit_Days: "",
        //   DC_Date: "",
        //   Dc_No: "",
        //   Due_Date: "",
        //   Invoice_Date: "",
        //   Invoice_No: "",
        //   MRN_No: "",
        //   Security_Date: "",
        //   Security_No: "",
        // });
        // setQuantities({});
        // setSelectedPOs([]);
        break;

      case "edit":
        setFormMode("edit");
        setShowCreateForm(false);   // ✅ MUST
        setIsModalOpen(false);      // ✅ MUST

        setShowViewForm(false);
        setShowEditForm(true);
        break;
      case "view":
        setFormMode("view");

        setShowCreateForm(false);   // ✅ MUST
        setIsModalOpen(false);      // ✅ MUST

        setShowEditForm(false);
        setShowViewForm(true);
        break;

      case "save":
        if (formMode === "view") return;

        if (formMode === "edit") {
          handleEditSubmit();
        } else if (formMode === "create") {
          handleSave();
        }
        break;

      default:
        break;
    }

  }, [screenAction, formMode]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewForm, setShowViewForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);

  const user = JSON.parse(sessionStorage.getItem('user'));
  const id = user ? user.id : null;

  const [selectedPOs, setSelectedPOs] = useState([]);


  const [poList, setPoList] = useState(['']);

  const [supplierList, setSupplierList] = useState([]); // Supplier data

  const [supplierFilter, setSupplierFilter] = useState(null);

  console.log(supplierList)

  const [allMrnDtlData, setAllMrnDtlData] = useState([]);

  const fetchData = async () => {
    try {
      const suppResponse = await axios.get('https://hmsapi.emedhatechnologies.com/master/api/purSuppMst');
      setSupplierList(suppResponse.data); // Assuming this API returns an array of suppliers

      // Fetch Purchase Orders
      const poResponse = await axios.get('https://hmsapi.emedhatechnologies.com/master/api/poget/MatirialReceipt');
      const mrnResponse = await axios.get('https://hmsapi.emedhatechnologies.com/master/api/mrn_dtl');

      // Step 1: Aggregate Accepted quantities for each PO and Item combination, considering unique MRNs
      const acceptedQtyMap = {}; // This will store aggregated accepted quantities for each PO_No + Item_cd combination
      const mrnProcessed = new Set(); // To keep track of processed MRNs and avoid double counting

      mrnResponse.data.forEach(mrnItem => {
        const key = `${mrnItem.PO_No}_${mrnItem.Item_cd}`;
        if (!acceptedQtyMap[key]) {
          acceptedQtyMap[key] = 0;
        }
        acceptedQtyMap[key] += Number(mrnItem.Accepted_qty); // ensure number
      });
      const updatedPoList = poResponse.data.map(po => {
        return {
          ...po,
          PO_DTL: po.PO_DTL.map(item => {
            const key = `${po.PO_HDR.PO_no}_${item.itemCd}`;
            const totalAcceptedQty = acceptedQtyMap[key] || 0;
            console.log('this is the totalacc', totalAcceptedQty)
            // Calculate the remaining quantity (PO_qty - total accepted qty)
            const remainingQty = item.PO_qty - totalAcceptedQty;
            console.log('this is remaningqty', remainingQty)
            // Ensure remaining quantity is non-negative
            const validRemainingQty = remainingQty >= 0 ? remainingQty : 0;

            return {
              ...item,
              remainingQty: validRemainingQty, // Add the calculated remaining quantity
            };
          })
            .filter(item => item.remainingQty > 0),
        };
      });

      // Step 3: Set the updated PO list to state
      setPoList(updatedPoList);
      setAllMrnDtlData(mrnResponse);

    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log('this is the poList', poList)

  const getSuppliername = (suppId) => {
    const supplier = supplierList.find(supplier => supplier.Supp_cd === suppId);
    return supplier ? supplier.Supp_Nm : "No Supplier";
  };


  const getSupplierName = (supp_id) => {
    const supplier = supplierList.find(s => s.Supp_cd === supp_id);
    return supplier ? supplier.Supp_Nm : 'Unknown Supplier'; // Return supplier name or 'Unknown Supplier' if not found
  };

  const [Supp_id, setSelectedSupplier] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [states, setStates] = useState({});
  const [stateMaster, setStateMaster] = useState({});
  // const [items, setItems] = useState('');
  const [Des_gst, setDesGst] = useState('');
  const [Des_state_cd, setDesState] = useState('');

  useEffect(() => {
    axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/suppliers')
      .then((response) => {
        setSuppliers(response.data);
      })
      .catch((error) => {
        console.error('Error fetching suppliers:', error);
      });
    axios.get('https://hmsapi.emedhatechnologies.com/master/api/api/states')
      .then((response) => {
        setStates(response.data);
        setStateMaster(response.data);
      })
      .catch((error) => {
        console.error('Error fetching state master:', error);
      });

  }, []);

  const [stateName, setStateName] = useState('');
  const [stateCode, setStateCode] = useState('');

  useEffect(() => {
    // If we have a GST number and the states data is available, find the matching state
    if (selectedPOs.length > 0 && states) {
      const gst = selectedPOs[0].PO_HDR.Supp_gst;
      if (gst) {
        const stateCode = gst.slice(0, 2); // Get the first two characters of GST

        const state = states[stateCode]; // Get the state name using the state code
        setStateCode(stateCode);
        if (state) {
          setStateName(state); // Set the state name if found
        } else {
          setStateName('Unknown State'); // Handle if no state is found
        }
      }
    }
  }, [selectedPOs, states]);
  console.log(states); // Check the data structure of the state mappings
  console.log(stateCode)
  console.log(stateName)
  const supplier = suppliers.find(s => s.Supp_cd.toString() === Supp_id.toString());
  const extractStateFromGST = (gst) => {
    if (!gst) return '';
    const stateCode = gst.substring(0, 2);
    const stateName = states[stateCode] || 'Unknown State';
    return stateName;
  };



  const [companyData, setCompanyData] = useState([]);

  // const fetchCompanyData = async () => {
  //     try {
  //         const response = await axios.get(
  //             "https://hmsapi.emedhatechnologies.com/master/api/api/get-Company-data"
  //         );
  //         setCompanyData(response.data); // Store company data
  //     } catch (err) {
  //         console.error("Error fetching company data");
  //     }
  // };
  // useEffect(() => {
  //     fetchCompanyData();
  // }, []);

  const fetchCompanyData = async () => {
    try {
      // 1. Get logged-in user from localStorage
      const user = JSON.parse(localStorage.getItem("user"));

      // 2. Fetch employee data
      const empRes = await axios.get(
        "https://hmsapi.emedhatechnologies.com/master/api/api/get-Employee-data"
      );

      // 3. Find logged-in employee using email
      const loggedEmployee = empRes.data.find(
        (emp) => emp.email === user.email
      );

      if (!loggedEmployee) {
        console.error("Employee not found");
        return;
      }

      const hospitalId = loggedEmployee.hospital_id;

      // 4. Fetch company data
      const compRes = await axios.get(
        "https://hmsapi.emedhatechnologies.com/master/api/api/get-Company-data"
      );

      // 5. Filter company using hospital_id
      const matchedCompany = compRes.data.find(
        (comp) => comp.id === hospitalId
      );

      // 6. Store only matched company
      setCompanyData(matchedCompany);

    } catch (err) {
      console.error("Error fetching company data", err);
    }
  };

  useEffect(() => {
    fetchCompanyData();
  }, []);


  console.log('this is companyData', companyData)

  useEffect(() => {
    console.log("companyData inside useEffect:", companyData);
    console.log("GST_NO value:", companyData?.GST_NO);

    // if (companyData.length > 0) {
    if (companyData && companyData.GST_NO) {

      // Set the first GST_NO value in the Des_gst state
      console.log("Setting GST:", companyData.GST_NO);
      setDesGst(companyData.GST_NO);
    }
  }, [companyData]);

  useEffect(() => {
    console.log('Updated Des_gst:', Des_gst);
  }, [Des_gst]);



  const [desStateCode, setDesStateCode] = useState('')
  useEffect(() => {
    if (Des_gst && Des_gst.length >= 2) {
      const stateCode = Des_gst.substring(0, 2);
      setDesStateCode(stateCode);

      const stateName = stateMaster[stateCode] || 'Unknown State';
      setDesState(stateName);

      console.log("Auto setting stateCode:", stateCode);
      console.log("Auto setting stateName:", stateName);
    }
  }, [Des_gst]);

  const handleDesGstChange = (e) => {
    const Des_gst = e.target.value;
    console.log('this is gstValue', Des_gst)
    if (Des_gst.length <= 14) {
      setDesGst(Des_gst);
      if (Des_gst.length >= 2) {
        const stateCode = Des_gst.substring(0, 2);
        setDesStateCode(stateCode)
        const stateName = stateMaster[stateCode] || 'Unknown State';
        setDesState(stateName);
      } else {
        setDesState('');
      }
    }
  };


  console.log('this is DEsc state code', desStateCode)
  console.log('this is Des state name', Des_state_cd)



  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toISOString().split('T')[0];
    setCurrentDate(formattedDate);
  }, []);

  const [quantities, setQuantities] = useState({}); // Store quantities for each item

  const [formData, setFormData] = useState({
    Credit_Days: "",
    DC_Date: "",
    Dc_No: "",
    Due_Date: "",
    Invoice_Date: "",
    Invoice_No: "",

    Security_Date: "",
    Security_No: "",

  });
  const handleInputChange = (e) => {
    setFormData(prevData => ({
      ...prevData,
      MRN_No: e.target.value,
    }));
  };

  const handlePrint = () => {
    console.log('Print functionality');
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handlePOSelection1 = (po, item, isChecked) => {
    console.log(`Selected PO: ${po.PO_HDR.PO_no}, qtys: ${po.PO_DTL.map(item => item.qty)}`);

    if (isChecked) {
      setSelectedPOs(prevSelected => {
        const isAlreadySelected = prevSelected.some(selected =>
          selected.PO_HDR.PO_no === po.PO_HDR.PO_no && selected.PO_DTL.every(newItem =>
            selected.PO_DTL.some(selectedItem => selectedItem.qty === newItem.qty)
          )
        );

        if (!isAlreadySelected) {
          console.log(`Adding PO ${po.PO_HDR.PO_no} with qtys: ${po.PO_DTL.map(item => item.qty)}`);
          return [...prevSelected, po];  // Only add this PO to the selected list
        }
        return prevSelected;
      });
    } else {
      // Deselecting PO should remove it correctly
      setSelectedPOs(prevSelected => prevSelected.filter(selected =>
        selected.PO_HDR.PO_no !== po.PO_HDR.PO_no ||
        selected.PO_DTL.some(item => item.qty !== po.PO_DTL[0].qty)  // Ensure we are checking the selected qty for removal
      ));
    }
  };

  const handlePOSelection2 = (po, item, isChecked) => {
    const uniqueKey = `${po.PO_HDR.PO_no}_${item.itemCd}`;

    setSelectedPOs((prevSelected) => {
      if (isChecked) {
        // Add this specific item if not already selected
        const alreadySelected = prevSelected.some(
          (selected) =>
            selected.PO_HDR.PO_no === po.PO_HDR.PO_no &&
            selected.item.itemCd === item.itemCd
        );

        if (!alreadySelected) {
          console.log(`✅ Added: PO ${po.PO_HDR.PO_no}, Item ${item.itemCd}`);
          return [...prevSelected, { ...po, item }];
        }
        return prevSelected;
      } else {
        // Remove only the specific PO-item combination
        console.log(`❌ Removed: PO ${po.PO_HDR.PO_no}, Item ${item.itemCd}`);
        return prevSelected.filter(
          (selected) =>
            !(
              selected.PO_HDR.PO_no === po.PO_HDR.PO_no &&
              selected.item.itemCd === item.itemCd
            )
        );
      }
    });
  };

  const handlePOSelection3 = (po, item, isChecked) => {
    const uniqueKey = `${po.PO_HDR.PO_no}_${item.itemCd}`;

    setSelectedPOs((prevSelected) => {
      if (isChecked) {
        // Add only the selected PO-item combination
        const alreadySelected = prevSelected.some(
          (selected) =>
            selected.PO_HDR.PO_no === po.PO_HDR.PO_no &&
            selected.item.itemCd === item.itemCd
        );

        if (!alreadySelected) {
          console.log(`✅ Added: PO ${po.PO_HDR.PO_no}, Item ${item.itemCd}`);
          // Store only selected item, not the whole PO_DTL array
          return [...prevSelected, { PO_HDR: po.PO_HDR, item }];
        }
        return prevSelected;
      } else {
        // Remove the specific PO-item combination
        console.log(`❌ Removed: PO ${po.PO_HDR.PO_no}, Item ${item.itemCd}`);
        return prevSelected.filter(
          (selected) =>
            !(
              selected.PO_HDR.PO_no === po.PO_HDR.PO_no &&
              selected.item.itemCd === item.itemCd
            )
        );
      }
    });
  };

  const handlePOSelection = (po, item, isChecked) => {
    setSelectedPOs((prevSelected) => {
      const existingPO = prevSelected.find(
        (p) => p.PO_HDR.PO_no === po.PO_HDR.PO_no
      );

      if (isChecked) {
        // ✅ Add this PO item
        if (existingPO) {
          const alreadyHasItem = existingPO.PO_DTL.some(
            (i) => i.itemCd === item.itemCd
          );

          if (!alreadyHasItem) {
            const updatedPO = {
              ...existingPO,
              PO_DTL: [...existingPO.PO_DTL, item],
            };
            return prevSelected.map((p) =>
              p.PO_HDR.PO_no === po.PO_HDR.PO_no
                ? updatedPO
                : p
            );
          }
          return prevSelected; // no duplicate
        } else {
          // Add new PO with this single item
          return [
            ...prevSelected,
            { ...po, PO_DTL: [item] },
          ];
        }
      } else {
        // ❌ Remove this PO item
        if (existingPO) {
          const updatedItems = existingPO.PO_DTL.filter(
            (i) => i.itemCd !== item.itemCd
          );

          if (updatedItems.length > 0) {
            return prevSelected.map((p) =>
              p.PO_HDR.PO_no === po.PO_HDR.PO_no
                ? { ...p, PO_DTL: updatedItems }
                : p
            );
          } else {
            // If no items left for this PO, remove it entirely
            return prevSelected.filter(
              (p) => p.PO_HDR.PO_no !== po.PO_HDR.PO_no
            );
          }
        }
        return prevSelected;
      }
    });
  };

  console.log("selectedPo ", selectedPOs)

  const handleConfirm = () => {
    console.log('Confirm MRN creation');
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setSelectedPOs([]); // Clear selected POs
    setIsModalOpen(false); // Close modal
  };

  const handleApprove = (id) => {

  };
  const handleRefresh = () => {
    setSelectedPOs('');
    setStateName('');
    setStateCode("");
    setMRN_No("");

    setMrnHdrData("");
    setMrnDtlData("");
    setDesGst("");
    setDesState("");
    setFormData("");
    setStates("");
    setDesStateCode("");


  };

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const userPermissions = user && user.permissions && user.permissions[1000]
    ? {
      add: user.permissions[2000].sub_ids[2004]?.permissions.add_permission || 0,
      edit: user.permissions[2000].sub_ids[2004]?.permissions.edit_permission || 0,
      view: user.permissions[2000].sub_ids[2004]?.permissions.view_permission || 0,
      save: user.permissions[2000].sub_ids[2004]?.permissions.save_permission || 0,
      approve: user.permissions[2000].sub_ids[2004]?.permissions.approve_permission || 0,
      print: user.permissions[2000].sub_ids[2004]?.permissions.print_permission || 0,
      close: user.permissions[2000].sub_ids[2004]?.permissions.exit_permission || 0,
      clear: user.permissions[2000].sub_ids[2004]?.permissions.refresh_permission || 0
    }
    : {};

  const getButtonState = (permissionType) => {
    switch (formMode) {
      case 'create':
        return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
      case 'edit':
        return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
      case 'view':
        return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
      case 'approve':
        return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
      default:
        return false;
    }
  };

  const [MRN_No, setMRN_No] = useState(""); // Maintain MRN_No state

  // Fetch the latest MRN_No from the backend when the component mounts

  const fetchLatestMRN = async () => {
    try {
      const response = await fetch('https://hmsapi.emedhatechnologies.com/master/api/api/get-latest-mrn');
      const data = await response.json();
      const latestMRN = data.latestMRN;

      // Set MRN_No to the next available value
      setMRN_No(latestMRN === 0 ? "1" : (parseInt(latestMRN) + 1).toString());
    } catch (error) {
      console.error('Error fetching latest MRN:', error);
    }
  };
  useEffect(() => {
    fetchLatestMRN();
  }, []);


  const [mrnNos, setMrnNos] = useState([]); // List of MRN Nos
  const [selectedMRNNo, setSelectedMRNNo] = useState(""); // Selected MRN No


  const [mrnHdrData, setMrnHdrData] = useState({}); // MRN Header data
  const [mrnDtlData, setMrnDtlData] = useState([]); // MRN Details data
  console.log(mrnHdrData)
  console.log(mrnDtlData)
  useEffect(() => {
    // Fetch the list of MRN Nos for the dropdown
    axios.get("https://hmsapi.emedhatechnologies.com/master/api/mrn-nos").then((response) => {
      setMrnNos(response.data);
    });
  }, []);

  const fetchMRNData = async (selectedMRNNo) => {
    try {
      const response = await axios.get(`https://hmsapi.emedhatechnologies.com/master/api/mrn/${selectedMRNNo}`);
      setMrnHdrData(response.data.mrnHdrData);
      setMrnDtlData(response.data.mrnDtlData);
    } catch (error) {
      console.error("Error fetching MRN data:", error);
    }
  };

  useEffect(() => {
    if (selectedMRNNo) {
      fetchMRNData(selectedMRNNo);
    }
  }, [selectedMRNNo]);

  const handleSave = async () => {
    // Step 1: Validate form data
    // const isValid = Object.values(formData).every(value => value !== "");
    // console.log(isValid)
    console.log(formData)

    // 🚫 Prevent accidental save trigger
    // if (formMode !== "create" && formMode !== "edit") {
    //   return;
    // }

    //  const isValid = Object.values(formData).every(value => value !== "");

    //   if (!isValid) {
    //     alert("Please fill in all required fields.");
    //     return;
    //   }

    // if (formMode === "create" || formMode === "edit") {
    //   const isValid = Object.values(formData).every(value => value !== "");

    //   if (!isValid) {
    //     alert("Please fill in all required fields.");
    //     return;
    //   }
    // }

    // if (!isValid) {
    //   alert("Please fill in all required fields.");

    //   return;
    // }

    // Step 2: Prepare MRN_HDR data (Header)

    const user = JSON.parse(localStorage.getItem("user")) || {};

    const MRN_HDR = {

      Invoice_No: formData.Invoice_No,
      Dc_No: formData.Dc_No,
      Security_No: formData.Security_No,
      Des_GST: Des_gst,
      Des_State: desStateCode,
      MRN_Date: currentDate, // Use the state for current date
      Invoice_Date: formData.Invoice_Date,
      DC_Date: formData.DC_Date,
      Security_Date: formData.Security_Date,
      Supplier: selectedPOs.length > 0 ? selectedPOs[0].PO_HDR.Supp_id : "No Supplier",
      Credit_Days: formData.Credit_Days,
      Due_Date: formData.Due_Date,
      Supplier_GST: selectedPOs.length > 0 ? selectedPOs[0].PO_HDR.Supp_gst : "No Supplier",
      Supplier_State: stateCode,
      Created_by: user?.id,
    };


    // Step 3: Prepare MRN_DTL data (Details)
    const MRN_DTL = selectedPOs
      .map(po =>
        po.PO_DTL.map(item => {
          const receivedQty = parseFloat(quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Received_qty) || 0;

          const acceptedQty =
            parseFloat(
              quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Accepted_qty
            ) || 0;

          // Calculate Rejected Qty
          const rejectedQty = (receivedQty - acceptedQty).toFixed(2); // Reject Qty is auto-calculated.

          const itemCost = parseFloat(item.Actual_Rate) || 0;

          // ✅ Calculate total amount only when Accepted_qty > 0
          const acceptedAmount = acceptedQty > 0
            ? (acceptedQty * itemCost).toFixed(2)
            : itemCost.toFixed(2);

          return {
            PO_No: po.PO_HDR.PO_no,
            Item_Code: item.itemCd,
            Item_Description: item.itemDesc,
            UOM: item.UOM,
            HSN_Code: item.Hsn_code,
            GST_Percent: item.GST_per,
            PO_Qty: item.PO_qty,
            Received_Qty: quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Received_qty || '',
            Accepted_Qty: quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Accepted_qty || '',
            Rejected_Qty: rejectedQty || '',
            Total_Item_Cost: acceptedAmount, // ✅ new field
            Actual_Rate: itemCost,
          };
        })
      )
      .flat();

    // Step 4: Combine header and details data for posting
    const dataToPost = {
      mrnHdrData: MRN_HDR,
      mrnDtlData: MRN_DTL
    };

    console.log('this is datatopost', dataToPost)

    // Step 5: Post the data to the backend
    fetch('https://hmsapi.emedhatechnologies.com/master/api/api/mrn', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataToPost),
    })
      .then(response => response.json())
      .then(data => {
        console.log(`Data successfully posted:, ${data.MRN_No}`);
        // Handle success, e.g., show success message or clear the form 
        alert(`Data successfully posted:  MRN No is , ${MRN_No}`);

        fetchData();
        fetchMRNData(selectedMRNNo);
        fetchLatestMRN();
        // Optionally reset the form and clear selected POs
        setFormData({
          Credit_Days: "",
          DC_Date: "",
          Dc_No: "",
          Due_Date: "",
          Invoice_Date: "",
          Invoice_No: "",
          MRN_No: "",
          Security_Date: "",
          Security_No: "",
        });
        setSelectedPOs([]);
        setQuantities({}); // Reset quantities if needed
        window.location.reload();
      })
      .catch(error => {
        console.error('Error posting data:', error);
        alert("Error saving data. Please try again.");
      });
  };

  const handleMRNChange = (selectedOption) => {
    setSelectedMRNNo(selectedOption ? selectedOption.value : "");
  };

  const mrnOptions = mrnNos.map((mrn) => ({
    value: mrn,
    label: mrn,
  }));
  const handleEditSubmit = async () => {
    try {
      // Send PUT request to update MRN data
      const response = await axios.put(
        `https://hmsapi.emedhatechnologies.com/master/api/mrn/${selectedMRNNo}`,
        {
          mrnHdrData,
          mrnDtlData
        }
      );

      // Handle success response
      alert(response.data.message);  // Display success message
      window.location.reload();
    } catch (error) {
      console.error("Error updating MRN:", error);
      alert("Failed to update MRN data.");
    }
  };

  const rowsToDisplay = mrnDtlData.length >= 10 ? mrnDtlData : [...mrnDtlData, ...Array(10 - mrnDtlData.length).fill({})];

  function formatDateToDateInput(date) {
    // Convert date string to a Date object
    const dateObj = new Date(date);

    // Adjust for timezone offset and convert to 'YYYY-MM-DD' format
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = dateObj.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  // remaning qty of the edit 
  const getRemainingQty = (allMrnDtlData, mrnDtlAll) => {
    // Filter all MRNs for this PO + Item
    console.log('this is allMrnDtlData', allMrnDtlData)
    console.log('this is mrnDtlAll', mrnDtlAll)
    const poItemHistory = mrnDtlAll
      .filter(r => r.PO_No === allMrnDtlData.PO_No && r.Item_cd === allMrnDtlData.Item_cd)
      .sort((a, b) => a.MRN_No - b.MRN_No); // ensure sorted by MRN_No

    // Find index of current MRN in the history
    const currentIndex = poItemHistory.findIndex(r => r.MRN_No === allMrnDtlData.MRN_No);

    // If last MRN for this PO+Item → remaining = Rejected_qty
    if (currentIndex === poItemHistory.length - 1) {
      return Number(allMrnDtlData.Rejected_qty || 0);
    }

    // Else → remaining = PO_qty - sum of previous Accepted_qty
    const previousAcceptedSum = poItemHistory
      .slice(0, currentIndex)
      .reduce((sum, r) => sum + Number(r.Accepted_qty || 0), 0);

    return Number(allMrnDtlData.PO_qty || 0) - previousAcceptedSum;
  };


  return (
    <>
      <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>

        {showCreateForm && (
          <>
            {isModalOpen && (
              <div style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ backgroundColor: '#ffffff', padding: '16px', borderRadius: '8px', width: '80%' }}>
                  <h4 className='text-center'>PENDING PURCHASE ORDERS</h4>
                  <div style={{ overflowY: 'auto', maxHeight: '200px' }}>
                    <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>PO</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Supplier CD</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Supplier Name</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Desc</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Quantity</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>PO_QTY</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remaining_qty</th>
                          <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Selection</th>
                        </tr>
                      </thead>

                      <tbody>
                        {
                          // Ensure poList is defined and filter for valid items
                          poList && poList.length > 0 && poList.filter(po => !supplierFilter || po.PO_HDR.supplierCd === supplierFilter).map(po => (
                            // Ensure PO_DTL is an array before calling map
                            po.PO_DTL && Array.isArray(po.PO_DTL) && po.PO_DTL.map(item => (
                              <tr key={item.itemCd}>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{po.PO_HDR.PO_no}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{po.PO_HDR.Supp_id}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>
                                  {getSupplierName(po.PO_HDR.Supp_id)}
                                </td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.itemCd}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.itemDesc}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.UOM}</td>

                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.qty}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.PO_qty}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>{item.remainingQty}</td>
                                <td style={{ border: '1px solid black', padding: '8px' }}>
                                  <input
                                    type="checkbox"
                                    onChange={(e) => handlePOSelection(po, item, e.target.checked)}
                                  />
                                </td>
                              </tr>
                            ))
                          ))
                        }
                      </tbody>

                    </table>
                  </div>
                  <div style={{ marginTop: '16px' }}>
                    <button style={{ backgroundColor: "blue", color: 'white', padding: '2px 20px', borderRadius: '4px', marginRight: '10px', cursor: 'pointer' }} onClick={handleConfirm}>Confirm</button>
                    <button style={{ backgroundColor: "blue", color: 'white', padding: '2px 20px', borderRadius: '4px', marginRight: '10px', cursor: 'pointer' }} onClick={handleCancel}>Cancel</button>
                  </div>
                </div>
              </div>
            )}
            {selectedPOs.length > 0 && (
              <div>
                <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '83px', color: 'darkblue' }}>MRN No:</label>
                      <input
                        readOnly
                        // value={MRN_No}
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />

                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '69px', color: 'darkblue' }}>Invoice No:</label>
                      <input maxLength={12} pattern="[A-Za-z0-9]+" name='type'
                        type='text'
                        value={formData.Invoice_No}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Invoice_No: e.target.value,
                        }))}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '100px', color: 'darkblue' }}>Dc No:</label>
                      <input maxLength={12}
                        pattern="[A-Za-z0-9]+"
                        name='type' type='text'
                        value={formData.Dc_No}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Dc_No: e.target.value,
                        }))}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '63px', color: 'darkblue' }}>Security No:</label>
                      <input
                        type='text'
                        maxLength={6}
                        value={formData.Security_No}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Security_No: e.target.value,
                        }))}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Destination GST:</label>
                      <input maxLength={15} type="text" name="Des_gst" value={Des_gst} onChange={handleDesGstChange} autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '24px', color: 'darkblue' }}>Destination State:</label>
                      <input type="text" name="Des_state_cd" value={Des_state_cd} autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                  </div>

                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '40px', color: 'darkblue' }}>MRN Dt:</label>
                      <input
                        type='date'
                        value={currentDate} onChange={(e) => setCurrentDate(e.target.value)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '26px', color: 'darkblue' }}>Invoice Dt:</label>
                      <input
                        type='date'
                        value={formData.Invoice_Date}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Invoice_Date: e.target.value,
                        }))}
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '56px', color: 'darkblue' }}>DC Dt:</label>
                      <input
                        type='date'
                        value={formData.DC_Date}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          DC_Date: e.target.value,
                        }))}
                        pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '21px', color: 'darkblue' }}>Security Dt:</label>
                      <input
                        type='date'
                        value={formData.Security_Date}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Security_Date: e.target.value,
                        }))}
                        pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                  </div>

                  <div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <label style={{ marginRight: '44px', color: 'darkblue' }}>Supplier:</label>
                      <span
                        style={{
                          border: 'none',
                          borderLeft: '2px solid #D1D5DB',
                          padding: '10px',
                          width: '50%',
                          outline: 'none',
                          backgroundColor: 'transparent',
                          display: 'inline-block',
                        }}
                      >
                        {selectedPOs.length > 0
                          ? getSuppliername(selectedPOs[0].PO_HDR.Supp_id)
                          : "No Supplier"}

                      </span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '22px', color: 'darkblue' }}>Credit Days:</label>
                      <input
                        type="text"
                        maxLength={4}
                        value={formData.Credit_Days}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Credit_Days: e.target.value,
                        }))}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '54px', color: 'darkblue' }}>Due Dt:</label>
                      <input
                        type='date'
                        value={formData.Due_Date}
                        onChange={(e) => setFormData((prevData) => ({
                          ...prevData,
                          Due_Date: e.target.value,
                        }))}
                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <label style={{ marginRight: '14px', color: 'darkblue' }}>Supplier GST:</label>
                      <span
                        maxLength={12}
                        style={{
                          border: 'none',
                          borderLeft: '2px solid #D1D5DB',
                          padding: '10px',
                          width: '50%',
                          outline: 'none',
                          backgroundColor: 'transparent',
                          display: 'inline-block',
                        }}
                      >
                        {selectedPOs.length > 0 ? selectedPOs[0].PO_HDR.Supp_gst : "No Supplier"}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '6px', color: 'darkblue' }}>Supplier State:</label>
                      <input type="text" name="stateName" value={stateName} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                    </div>

                  </div>
                </div>
                <div style={{ overflowY: 'auto', maxHeight: '240px' }}>
                  <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>SI.No</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Po No</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>HSN CODE</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>GST %</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Qty</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>PO Qty</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remaining PO_Qty</th>

                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Received Qty</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Accepted Qty</th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Cost </th>
                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Rejected Qty</th>
                      </tr>
                    </thead>
                    <tbody>

                      {selectedPOs.map((po, index) => {
                        console.log(`Processing PO: ${po.PO_HDR.PO_no}`);
                        console.log('PO_DTL:', po.PO_DTL);

                        // Filter out items that don't match the selected qty (e.g., only show items with qty 16 if that's the selected qty)
                        return po.PO_DTL.filter(item => {
                          const selectedQty = item.qty;  // Ensure we're checking the correct item.qty
                          console.log(`Filtering item with qty: ${item.qty} against selected qty: ${selectedQty}`);
                          return selectedQty === item.qty;  // Compare to the selected qty
                        }).map(item => (
                          <tr key={item.itemCd}>
                            <td className="text-center" style={{ border: '1px solid black', padding: '8px' }}>{index + 1}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{po.PO_HDR.PO_no}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.itemCd}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.itemDesc}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.UOM}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.Hsn_code}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.GST_per}</td>

                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.qty}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.PO_qty}</td>
                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>{item.remainingQty}</td>

                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>
                              <input
                                type="text"
                                value={quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Received_qty || ""}


                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  console.log(`Updating Received_qty for PO_no: ${item.PO_no}, itemCd: ${item.itemCd}, qty: ${item.qty}`);

                                  if (!/^\d*\.?\d{0,2}$/.test(inputValue)) return;

                                  const enteredQty = parseFloat(inputValue) || 0;
                                  const remainingQty = parseFloat(item.remainingQty) || 0;

                                  if (enteredQty > remainingQty) {
                                    alert("Received Qty cannot be greater than Remaining PO Qty!");
                                    return;
                                  }
                                  if (inputValue.includes('.')) {
                                    let parts = inputValue.split('.');
                                    if (parts[1] && parts[1].length > 2) {
                                      e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
                                    }
                                  }

                                  setQuantities((prevQuantities) => {
                                    console.log('Previous Quantities:', prevQuantities);
                                    return {
                                      ...prevQuantities,
                                      [`${item.PO_no}_${item.itemCd}_${item.qty}`]: {
                                        ...prevQuantities[`${item.PO_no}_${item.itemCd}_${item.qty}`],
                                        Received_qty: e.target.value,
                                      },
                                    };
                                  });
                                }}


                                style={{ width: '100px', border: 'black', outline: 'black', backgroundColor: 'transparent' }}
                                maxLength={10}
                              />
                            </td>

                            <td
                              className="text-center"
                              style={{
                                minWidth: "100px",
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              <input
                                type="text"
                                value={
                                  quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Accepted_qty || ""
                                }
                                onChange={(e) => {
                                  const inputValue = e.target.value;

                                  // ✅ Allow only numbers and one optional decimal point
                                  if (!/^\d*\.?\d{0,2}$/.test(inputValue)) return;



                                  // ✅ Get Received Qty
                                  const receivedQty =
                                    parseFloat(
                                      quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Received_qty
                                    ) || 0;

                                  const enteredQty = parseFloat(inputValue) || 0;

                                  // ✅ Validation: Accepted qty must not exceed received qty
                                  if (enteredQty > receivedQty) {
                                    alert("Accepted Qty cannot be greater than Received Qty!");
                                    // Clear the input value immediately
                                    setQuantities((prevQuantities) => ({
                                      ...prevQuantities,
                                      [`${item.PO_no}_${item.itemCd}_${item.qty}`]: {
                                        ...prevQuantities[`${item.PO_no}_${item.itemCd}_${item.qty}`],
                                        Accepted_qty: "",
                                      },
                                    }));
                                    return;
                                  }

                                  // ✅ Update Accepted_qty if valid
                                  setQuantities((prevQuantities) => ({
                                    ...prevQuantities,
                                    [`${item.PO_no}_${item.itemCd}_${item.qty}`]: {
                                      ...prevQuantities[`${item.PO_no}_${item.itemCd}_${item.qty}`],
                                      Accepted_qty: inputValue,
                                    },
                                  }));
                                }}
                                style={{
                                  width: "100px",
                                  border: "black",
                                  outline: "black",
                                  backgroundColor: "transparent",
                                  textAlign: "left",
                                }}
                                maxLength={10}
                              />
                            </td>


                            <td
                              className="text-center"
                              style={{
                                minWidth: "100px",
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              {(() => {
                                const acceptedQty =
                                  parseFloat(
                                    quantities[`${item.PO_no}_${item.itemCd}_${item.qty}`]?.Accepted_qty
                                  ) || 0;

                                const itemCost = parseFloat(item.Actual_Rate) || 0;

                                // ✅ Only calculate when Accepted_qty is entered
                                if (acceptedQty > 0) {
                                  return (acceptedQty * itemCost).toFixed(2);
                                } else {
                                  return itemCost.toFixed(2);
                                }
                              })()}
                            </td>


                            <td className="text-center" style={{ minWidth: '100px', border: '1px solid black', padding: '8px' }}>
                              {(() => {
                                const key = `${item.PO_no}_${item.itemCd}_${item.qty}`;
                                const received = parseFloat(quantities[key]?.Received_qty) || 0;

                                const accepted = parseFloat(quantities[key]?.Accepted_qty) || 0;

                                const rejected = received - accepted;
                                return rejected > 0 ? rejected.toFixed(2) : "0.00";
                              })()}
                            </td>
                          </tr>
                        ));
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>

        )}

        {showEditForm && (

          <div>
            <div className="p-1" style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
              <div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "83px", color: "darkblue" }}>MRN No:</label>

                  <Select
                    options={mrnOptions}
                    value={mrnOptions.find((option) => option.value === selectedMRNNo)}
                    onChange={handleMRNChange}
                    placeholder="Search MRN No"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "60%", // Width of the select box
                      }),
                      control: (provided) => ({
                        ...provided,
                        height: "40px", // Control the height of the input box                      
                        backgroundColor: "transparent",
                        border: "2px solid #D1D5DB", // Border style
                      }),
                      menu: (provided) => ({
                        ...provided,

                        overflowY: "auto", // Scroll if exceeds height
                      }),
                      option: (provided) => ({
                        ...provided,
                        padding: "10px", // Padding for options
                      }),
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "69px", color: "darkblue" }}>Invoice No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Invoice_no}
                    onChange={(e) => {
                      setMrnHdrData({ ...mrnHdrData, Invoice_no: e.target.value });
                    }}

                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "100px", color: "darkblue" }}>Dc No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Dc_no || ""}
                    onChange={(e) => {
                      // Update the Invoice_no value based on input
                      setMrnHdrData({ ...mrnHdrData, Dc_no: e.target.value });
                    }}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "63px", color: "darkblue" }}>Security No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Security_no || ""}
                    onChange={(e) => {
                      // Update the Invoice_no value based on input
                      setMrnHdrData({ ...mrnHdrData, Security_no: e.target.value });
                    }}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Destination GST:</label>
                  <input maxLength={12} type="text" name="Des_gst" value={mrnHdrData.Des_gst}
                    onChange={(e) => {
                      // Update the Invoice_no value based on input
                      setMrnHdrData({ ...mrnHdrData, Des_gst: e.target.value });
                    }}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>


                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '24px', color: 'darkblue' }}>Destination State:</label>
                  <input type="text" name="Des_state_cd"
                    value={mrnHdrData.Des_state_cd}
                    onChange={(e) => {
                      setMrnHdrData({ ...mrnHdrData, Des_state_cd: e.target.value });
                    }}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
              </div>

              <div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '40px', color: 'darkblue' }}>MRN Dt:</label>
                  <input
                    type="date"
                    value={
                      mrnHdrData.MRN_Dt
                        ? formatDateToDateInput(mrnHdrData.MRN_Dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    onChange={(e) => {
                      const updatedMRNData = { ...mrnHdrData, MRN_Dt: e.target.value };
                      setMrnHdrData(updatedMRNData); // Set updated MRN_Dt
                    }}
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px',
                      width: '50%',
                      outline: 'none',
                      backgroundColor: 'transparent',
                    }}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "10px", color: "darkblue" }}>Invoice Date:</label>
                  <input
                    type="date"
                    // value={mrnHdrData.Invoice_dt ? new Date(mrnHdrData.Invoice_dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    value={
                      mrnHdrData.Invoice_dt
                        ? formatDateToDateInput(mrnHdrData.Invoice_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    onChange={(e) => {
                      const updatedMRNData = { ...mrnHdrData, Invoice_dt: e.target.value };
                      setMrnHdrData(updatedMRNData); // Set updated MRN_Dt
                    }}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '56px', color: 'darkblue' }}>DC Dt:</label>
                  <input

                    type="date"
                    // value={mrnHdrData.DC_Dt ? new Date(mrnHdrData.DC_Dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    value={
                      mrnHdrData.DC_Dt
                        ? formatDateToDateInput(mrnHdrData.DC_Dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    onChange={(e) => {
                      const updatedMRNData = { ...mrnHdrData, DC_Dt: e.target.value };
                      setMrnHdrData(updatedMRNData); // Set updated MRN_Dt
                    }}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '21px', color: 'darkblue' }}>Security Dt:</label>
                  <input
                    // value={mrnHdrData.Security_dt ? new Date(mrnHdrData.Security_dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    type="date"
                    value={
                      mrnHdrData.Security_dt
                        ? formatDateToDateInput(mrnHdrData.Security_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    onChange={(e) => {
                      const updatedMRNData = { ...mrnHdrData, Security_dt: e.target.value };
                      setMrnHdrData(updatedMRNData); // Set updated MRN_Dt
                    }}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '44px', color: 'darkblue' }}>Supplier:</label>
                  <input
                    // value={mrnHdrData.Supplier_cd}
                    value={
                      supplierList.find(supplier => supplier.Supp_cd === mrnHdrData.Supplier_cd)?.Supp_Nm || ''
                    }
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px',
                      width: '50%',
                      outline: 'none',
                      backgroundColor: 'transparent',
                      display: 'inline-block',
                    }}
                  >
                  </input>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '22px', color: 'darkblue' }}>Credit Days:</label>
                  <input

                    maxLength={4}
                    value={mrnHdrData.Credit_days}
                    onChange={(e) => {
                      setMrnHdrData({ ...mrnHdrData, Credit_days: e.target.value });
                    }}

                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '54px', color: 'darkblue' }}>Due Dt:</label>
                  <input type="date"
                    value={
                      mrnHdrData.Due_dt
                        ? formatDateToDateInput(mrnHdrData.Due_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    onChange={(e) => {
                      const updatedMRNData = { ...mrnHdrData, Due_dt: e.target.value };
                      setMrnHdrData(updatedMRNData); // Set updated MRN_Dt
                    }}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '14px', color: 'darkblue' }}>Supplier GST:</label>
                  <input
                    value={mrnHdrData.Supp_gst}
                    maxLength={12}
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px',
                      width: '50%',
                      outline: 'none',
                      backgroundColor: 'transparent',
                      display: 'inline-block',
                    }}
                  >

                  </input>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '6px', color: 'darkblue' }}>Supplier State:</label>
                  <input type="text" value={mrnHdrData.Supp_state_cd}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
              </div>
            </div>

            <div style={{ overflowY: "auto", maxHeight: "300px" }}>
              <table style={{ minWidth: "100%", borderCollapse: "collapse", border: "1px solid black" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>SI.No</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>PO No</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Item Code</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>UOM</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>HSN CODE</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>GST %</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>PO Qty</th>

                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Received Qty</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Accepted Qty</th>
                    <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Total Item Cost</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Rejected Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToDisplay.map((item, index) => {
                    console.log('this is item', item)
                    return (
                      <tr key={index}>
                        <td style={{ border: "1px solid black", padding: "8px" }}>{index + 1}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.PO_No}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Item_cd}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.UOM}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Hsn_code}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.GST_Rate}</td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.PO_qty}</td>


                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>
                          <input
                            type='text'
                            value={item.Received_qty}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes('.')) {

                                let parts = inputValue.split('.');
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
                                }
                              }
                              const updatedData = [...mrnDtlData];
                              updatedData[index].Received_qty = e.target.value;
                              setMrnDtlData(updatedData);
                            }}
                            style={{
                              width: '90px',
                              border: 'black',
                              outline: 'black',
                              backgroundColor: 'transparent',

                            }}
                            maxLength={10}
                          />
                        </td>
                        <td style={{ border: "1px solid black", padding: "8px" }}>
                          <input
                            type='number'
                            value={item.Accepted_qty}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes('.')) {

                                let parts = inputValue.split('.');
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
                                }
                              }
                              const updatedData = [...mrnDtlData];
                              updatedData[index].Accepted_qty = e.target.value;
                              const updatedItem = updatedData[index];
                              if (inputValue === '' || parseFloat(inputValue) === 0) {
                                // If Accepted_qty is empty or 0, keep the original Total_Item_Cost
                                updatedItem.Total_Item_Cost = updatedItem.Total_Item_Cost;
                              } else {
                                // Otherwise, calculate the Total_Item_Cost based on Accepted_qty and Actual_Rate
                                updatedItem.Total_Item_Cost = parseFloat(inputValue) * updatedItem.Actual_Rate;
                              }
                              setMrnDtlData(updatedData);
                            }}
                            style={{
                              width: '90px',
                              border: 'none',
                              outline: 'none',
                              backgroundColor: 'transparent',
                              textAlign: 'left'
                            }}
                          />
                        </td>
                        <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>
                          {item.Total_Item_Cost}
                        </td>



                        <td style={{ border: "1px solid black", padding: "8px" }}>
                          <input
                            type='number'
                            value={item.Rejected_qty}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes('.')) {

                                let parts = inputValue.split('.');
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
                                }
                              }
                              const updatedData = [...mrnDtlData];
                              updatedData[index].Rejected_qty = e.target.value;
                              setMrnDtlData(updatedData);
                            }}
                            style={{
                              width: '90px',
                              border: 'none',
                              outline: 'none',
                              backgroundColor: 'transparent',
                              textAlign: 'left'
                            }}
                          />
                        </td>

                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>


        )}



        {showViewForm && (

          <div>
            <div className="p-1" style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
              <div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "83px", color: "darkblue" }}>MRN No:</label>

                  {/* Replace the standard select with react-select */}
                  <Select
                    options={mrnOptions}
                    value={mrnOptions.find((option) => option.value === selectedMRNNo)}
                    onChange={handleMRNChange}
                    placeholder="Search MRN No"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "60%", // Width of the select box
                      }),
                      control: (provided) => ({
                        ...provided,
                        height: "40px", // Control the height of the input box                      
                        backgroundColor: "transparent",
                        border: "2px solid #D1D5DB", // Border style
                      }),
                      menu: (provided) => ({
                        ...provided,

                        overflowY: "auto", // Scroll if exceeds height
                      }),
                      option: (provided) => ({
                        ...provided,
                        padding: "10px", // Padding for options
                      }),
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "69px", color: "darkblue" }}>Invoice No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Invoice_no}
                    readOnly
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "100px", color: "darkblue" }}>Dc No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Dc_no || ""}
                    readOnly
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "63px", color: "darkblue" }}>Security No:</label>
                  <input
                    type="text"
                    value={mrnHdrData.Security_no || ""}
                    readOnly
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Destination GST:</label>
                  <input maxLength={12} type="text" name="Des_gst" value={mrnHdrData.Des_gst} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>


                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '24px', color: 'darkblue' }}>Destination State:</label>
                  <input type="text" name="Des_state_cd" value={mrnHdrData.Des_state_cd} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>

              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '40px', color: 'darkblue' }}>MRN Dt:</label>
                  <input
                    type="date"
                    value={
                      mrnHdrData.MRN_Dt
                        ? formatDateToDateInput(mrnHdrData.MRN_Dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    readOnly
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px', width: '50%',
                      outline: 'none', backgroundColor: 'transparent'
                    }} />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "10px", color: "darkblue" }}>Invoice Date:</label>
                  <input
                    type="date"
                    // value={mrnHdrData.Invoice_dt ? new Date(mrnHdrData.Invoice_dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    value={
                      mrnHdrData.Invoice_dt
                        ? formatDateToDateInput(mrnHdrData.Invoice_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    readOnly
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "10px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '56px', color: 'darkblue' }}>DC Dt:</label>
                  <input
                    readOnly
                    type="date"
                    // value={mrnHdrData.DC_Dt}
                    // value={mrnHdrData.DC_Dt ? new Date(mrnHdrData.DC_Dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    value={
                      mrnHdrData.DC_Dt
                        ? formatDateToDateInput(mrnHdrData.DC_Dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '21px', color: 'darkblue' }}>Security Dt:</label>
                  <input
                    type="date"
                    //value={mrnHdrData.Security_dt ? new Date(mrnHdrData.Security_dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    value={
                      mrnHdrData.Security_dt
                        ? formatDateToDateInput(mrnHdrData.Security_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    // value={mrnHdrData.Security_dt}
                    readOnly
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
              </div>

              <div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '44px', color: 'darkblue' }}>Supplier:</label>
                  <input
                    // value={mrnHdrData.Supplier_cd }
                    value={
                      supplierList.find(supplier => supplier.Supp_cd === mrnHdrData.Supplier_cd)?.Supp_Nm || ''
                    }
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px',
                      width: '50%',
                      outline: 'none',
                      backgroundColor: 'transparent',
                      display: 'inline-block',
                    }}
                  >

                  </input>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '22px', color: 'darkblue' }}>Credit Days:</label>
                  <input

                    maxLength={4}
                    value={mrnHdrData.Credit_days
                    }

                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '54px', color: 'darkblue' }}>Due Dt:</label>
                  <input
                    type="date"
                    // value={mrnHdrData.Due_dt}
                    value={
                      mrnHdrData.Due_dt
                        ? formatDateToDateInput(mrnHdrData.Due_dt) // Format the date for the input field
                        : '' // If there's no date, show an empty input
                    }
                    //value={mrnHdrData.Due_dt ? new Date(mrnHdrData.Due_dt).toISOString().split('T')[0].split('-').reverse().join('-') : ''}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label style={{ marginRight: '14px', color: 'darkblue' }}>Supplier GST:</label>
                  <input
                    value={mrnHdrData.Supp_gst}
                    maxLength={12}
                    style={{
                      border: 'none',
                      borderLeft: '2px solid #D1D5DB',
                      padding: '10px',
                      width: '50%',
                      outline: 'none',
                      backgroundColor: 'transparent',
                      display: 'inline-block',
                    }}
                  >

                  </input>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '6px', color: 'darkblue' }}>Supplier State:</label>
                  <input type="text" value={mrnHdrData.Supp_state_cd}
                    style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                </div>
              </div>
            </div>

            <div style={{ overflowY: "auto", maxHeight: "300px" }}>
              <table style={{ minWidth: "100%", borderCollapse: "collapse", border: "1px solid black" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>SI.No</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>PO No</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Item Code</th>
                    {/* <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Item Description</th> */}
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>UOM</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>HSN CODE</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>GST %</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>PO Qty</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Received Qty</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Accepted Qty</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Total Item Cost</th>
                    <th style={{ border: "1px solid black", textAlign: "center", color: "darkblue" }}>Rejected Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {mrnDtlData.map((item, index) => ( */}
                  {/* {(mrnDtlData.length > 0 ? mrnDtlData : Array(4).fill({})).map((item, index) => ( */}
                  {rowsToDisplay.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid black", padding: "8px" }}>{index + 1}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.PO_No}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Item_cd}</td>
                      {/* <td style={{ border: "1px solid black", padding: "8px" }}>{item.itemDesc}</td> */}
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.UOM}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Hsn_code}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.GST_Rate}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.PO_qty}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Received_qty}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Accepted_qty}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px" }}>{item.Total_Item_Cost}</td>
                      <td style={{ minWidth: '90px', border: "1px solid black", padding: "8px", }}>{item.Rejected_qty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>


        )}


      </div>

    </>
  );
};


/* ================= STYLES ================= */
const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'blur(4px)'
  },

  modal: {
    background: '#f8fafc',
    padding: '20px',
    borderRadius: '12px',
    width: '85%',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
  },

  heading: {
    textAlign: 'center',
    color: '#334155',
    marginBottom: '10px'
  },

  tableContainer: {
    overflowY: 'auto',
    maxHeight: '260px'
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },

  thead: {
    background: '#e2e8f0'
  },

  th: {
    padding: '10px',
    color: '#1e293b',
    textAlign: 'center'
  },

  td: {
    padding: '8px',
    textAlign: 'center',
    borderBottom: '1px solid #e2e8f0',
    color: '#334155'
  },

  rowEven: { background: '#ffffff' },
  rowOdd: { background: '#f1f5f9' },

  buttonRow: {
    marginTop: '15px',
    textAlign: 'right'
  },

  primaryBtn: {
    background: '#3b82f6',
    color: '#fff',
    padding: '6px 16px',
    borderRadius: '6px',
    border: 'none',
    marginRight: '10px'
  },

  secondaryBtn: {
    background: '#64748b',
    color: '#fff',
    padding: '6px 16px',
    borderRadius: '6px',
    border: 'none'
  },

  formContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#f8fafc',
    padding: '15px',
    borderRadius: '10px',
    marginBottom: '15px'
  },

  formRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px'
  },

  label: {
    minWidth: '140px',
    color: '#334155'
  },

  input: {
    padding: '8px',
    border: '1px solid #cbd5e1',
    borderRadius: '6px',
    width: '150px'
  },

  inputSmall: {
    width: '80px',
    padding: '5px',
    border: '1px solid #cbd5e1',
    borderRadius: '4px'
  },

  readOnly: {
    padding: '8px',
    background: '#f1f5f9',
    borderRadius: '6px'
  }
};

export default MatirialReceipt;